import { Modal } from "../../ui/components/Modal";
import { Document, Page } from "react-pdf";
import "@unleashed/utils/pdfWorkerSetup";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "../utils/chatbotPDFPlugin.css";
import { useGetSourceDocumentQuery } from "../api/wingmanAdminAPI";
import { t } from "i18next";
import { useState } from "react";

export const ChatbotConversationResponseSource = ({ sourceDocument, closeModal }: { sourceDocument : string, closeModal : () => void }) => {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [scale, setScale] = useState(1);

  const { data, isLoading } = useGetSourceDocumentQuery({ file_name: sourceDocument });

  const handleLoaded = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <Modal
        fullSize={true}
        className="w-auto lg:w-1/2 mx-auto"
        title={sourceDocument}
        onClose={closeModal}
      >
        <div className="flex flex-col h-full">
          {data?.fileUrl && (
            <>
              <div className="flex items-center justify-center gap-4 py-2 border-b border-gray-300 text-sm">
                <button
                  className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
                  disabled={currentPage <= 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  {t`Previous`}
                </button>
                <span>
                  {currentPage} / {numPages}
                </span>
                <button
                  className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
                  disabled={currentPage >= numPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  {t`Next`}
                </button>
                <button
                  className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
                  disabled={scale <= 0.5}
                  onClick={() => setScale((s) => Math.round((s - 0.25) * 100) / 100)}
                >
                  -
                </button>
                <span>{Math.round(scale * 100)}%</span>
                <button
                  className="px-2 py-1 bg-gray-200 rounded disabled:opacity-50"
                  disabled={scale >= 3}
                  onClick={() => setScale((s) => Math.round((s + 0.25) * 100) / 100)}
                >
                  +
                </button>
              </div>
              <div className="flex-1 overflow-auto">
                <Document
                  file={data.fileUrl}
                  onLoadSuccess={handleLoaded}
                  loading={
                    <>
                      <div className="z-[6000] fixed inset-0 flex justify-center items-center bg-black opacity-50"/>
                      <div className="z-[7000] fixed inset-0 flex justify-center items-center flex-col">
                        <img className="z-10 max-h-24 max-w-24" src="/spinner.gif" alt="spinner"/>
                      </div>
                    </>
                  }
                >
                  <Page
                    pageNumber={currentPage}
                    scale={scale}
                    renderTextLayer={true}
                    renderAnnotationLayer={true}
                  />
                </Document>
              </div>
            </>
          )}
          {!data?.fileUrl && !isLoading && (
            <div className="flex flex-col items-center justify-center h-full">
              <div className="w-32 h-32 flex-shrink-0 mb-4">
                <img
                  src="/UB-Wingman-AI-Icon-No-Wings.png"
                  alt="Wingman Avatar"
                  className="w-full h-full rounded-full"
                />
              </div>
              <p>{t`The source PDF is not available to be viewed.`}</p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
